// OutboxSync — menguras antrian transaksi offline ke server: saat menjadi
// online, saat mount, dan berkala (30 dtk). Tak merender apa pun. Dipasang di
// root agar berjalan di halaman mana pun (US-OFFLINE-2).

import { useEffect } from "react";
import { useAuth } from "../lib/auth";
import { useOnline } from "../lib/useOnline";
import { flushOutbox, useOutboxCount } from "../data/outbox";

export function OutboxSync() {
  const { token } = useAuth();
  const online = useOnline();
  const pending = useOutboxCount();

  useEffect(() => {
    if (!token || !online || pending === 0) return;
    let cancelled = false;
    const run = () => {
      if (!cancelled) void flushOutbox(token);
    };
    run();
    const id = window.setInterval(run, 30000);
    return () => {
      cancelled = true;
      window.clearInterval(id);
    };
  }, [token, online, pending]);

  return null;
}
